<template>
  <div class="checkout-builder-image-modal py-3 px-6">
    <div class="d-flex justify-content-between align-items-center mb-6">
      <h3>Inserir imagem</h3>
      <button
        class="btn btn-sm py-3 px-4 btn-circle btn-new-secondary"
        @click="$emit('close')"
      >
        <i class="fa fa-close" />
      </button>
    </div>

    <bp-checkbox-group
      class="mb-5"
      v-model="form.config.display"
      :options="[
        { id: 'mobile', name: 'Versão para celular' },
        { id: 'desktop', name: 'Versão para computador' }
      ]"
    />

    <bp-input-file class="my-7 w-100" is-image v-model="form.image" />

    <bp-select
      v-model="form.config.aspectRatio"
      class="my-7"
      id="aspect-ratio"
      label="Tamanho da imagem"
      description="Largura máxima de 1110px"
      :options="ratioOptions"
    />

    <div class="d-flex flex-column flex-lg-row justify-content-end gap-5">
      <bp-button
        class="order-0 order-lg-1"
        label="Inserir imagem"
        @click="save"
        :disabled="!isValid"
      />
      <bp-button
        color="neutral"
        variant="filled-1"
        label="Cancelar"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
export default {
  props: {
    position: {
      type: String,
      default: ""
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const aspectRatio = this.position == "side" ? "1" : "4.625";
    const component = {
      ...this.data,
      config: {
        aspectRatio,
        ...this.data.config,
        width: "100%",
        "object-fit": "cover"
      }
    };

    return {
      ...formFields(["image", "config"], {
        ...component,
        config: { display: ["desktop", "mobile"], ...component.config }
      }),
      ratioOptions: [
        { id: aspectRatio, name: "Ajustar às dimensões recomendadas" },
        { id: "unset", name: "Tamanho original" }
      ]
    };
  },
  computed: {
    isValid() {
      return this.form.image && this.form.config?.aspectRatio;
    }
  },
  methods: {
    save() {
      this.$emit("save", { ...this.data, type: "image", ...this.form });
    }
  }
};
</script>

<style lang="scss">
.checkout-builder-image-modal {
  .bp-input-file .input-container {
    aspect-ratio: 2.7;
  }
}
</style>
